import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Auth, FormSelect } from 'components/Form/Form';
import Spinner from 'components/0components/Spinner';
import Button from 'components/0components/Button';
import { yearsListBetween } from 'lib/utils';
import FormatDate from 'lib/FormatDate';
import { ParametresApi } from 'api/ParametresApi';

import CalendrierLayout from './CalendrierLayout';

export default ({ id }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (<div onClick={_ => setIsVisible(true)}>
        <Button>PDF - Calendrier</Button>
        {isVisible && <MyModal isVisible={isVisible} setIsVisible={setIsVisible} id={id} />}
    </div>);
}

const MyModal = ({ isVisible, setIsVisible, id }) => {

    const beginYear = 1979; //pour le modal
    const curentYear = new Date().getFullYear()
    const endYear = curentYear + 2; //pour le modal

    const [annee, setAnnee] = useState(curentYear); //année de recherche

    const [respCalProv, setRespCalProv] = useState();
    const [respCalClub, setRespCalClub] = useState();
    const [paramDateLimite, setParamDateLimit] = useState();
    const [club, setClub] = useState();
    const [marches, setMarches] = useState();

    useEffect(_ => {
        setClub();
        fetch(`api/clubs/${id}`, Auth.requestOptions("GET"))
            .then(res => res.json())
            .then(res => setClub(res));
    }, [id]);

    useEffect(_ => {
        setMarches();
        fetch(`api/marches/export/club?clubid=${id}&startDate=${annee}-01-01&endDate=${annee}-12-31`, Auth.requestOptions("GET"))
            .then(res => res.json())
            .then(res => setMarches(res));
    }, [id, annee]);

    useEffect(_ => {
        setRespCalProv()
        fetch(`api/v1/orga/${id}/prov/Calendrier`, Auth.requestOptions("GET"))
            .then(res => res.json())
            .then(res => setRespCalProv(res));
    }, [id]);

    useEffect(_ => {
        setRespCalClub()
        fetch(`api/v1/orga/${id}/Calendrier`, Auth.requestOptions("GET"))
            .then(res => res.json())
            .then(res => setRespCalClub(res));
    }, [id]);

    useEffect(_ => {
        setParamDateLimit();
        ParametresApi.get("CAL_EXPORT_DATELIMIT")
            .then(res => setParamDateLimit(FormatDate(res.value)));
    }, []);

    const canPdfBeGenerated = paramDateLimite && club && marches && respCalProv && respCalClub;

    return (<Modal isOpen={isVisible} toggle={_ => setIsVisible(false)}>
        <ModalHeader toggle={_ => setIsVisible(false)}>Génération Calendrier</ModalHeader>
        <ModalBody>
            <FormSelect label="Année" required value={annee} handleChange={val => setAnnee(val)}>
                {yearsListBetween(beginYear, endYear).map((e, i) => <option value={e} key={i}>{e}</option>)}
            </FormSelect>
            {canPdfBeGenerated &&
                <CalendrierLayout
                    calendrierProjet={{
                        marches: marches,
                        club: club,
                        annee: annee,
                        responsableProvince: respCalProv,
                        responsableClub: respCalClub,
                        dateLimite: paramDateLimite
                    }}
                    fileName={`Calendrier_Club_${club?.matricule}_${annee}`} />}
            {!canPdfBeGenerated && <>
                <p>Chargement des données...</p>
                <Spinner />
            </>}
        </ModalBody>
    </Modal>);
}
